import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GlobalService {
  constructor() { }
}

//export const API_URL = 'http://localhost/unblock/api-panel/public';

const PRODUCTION_URLS = {
  api: 'https://panelapi.unblockthecity.com/',
 // api: 'https://panelapi.unblockthecity.com/',

  cdn: 'https://cdn.unblockthecity.com'
};

const DEV_URLS = {
  api: 'https://panelapi.unblockthecity.com/',
 // api: 'https://panelapi.unblockthecity.com/',

  cdn: 'https://cdn.unblockthecity.com'
};

/*const DEV_URLS = {
  api: 'http://localhost:8000',
  cdn: 'http://localhost:4200'
};*/

export const API_URL = environment.production ? PRODUCTION_URLS.api : DEV_URLS.api;
export const CDN_URL = environment.production ? PRODUCTION_URLS.cdn : DEV_URLS.cdn;
